import { sendEvent } from '@core/track'
import { sendInviteEmails } from '@services/invite-friends'
import { history } from '@store/history'
import cls from '@utils/css-select'
import Button from 'ac-components/ac-btn'
import AcIcon from 'ac-components/ac-icon'
import Input from 'ac-components/ac-ipt'
import Alert from 'ac-components/alert'
import { DisplayModal } from 'ac-components/modal'
import { emailReg } from 'constants/regXpRules'
import { EN_BECOME_TUTORS, EN_DOWNLOAD, EN_HOW_WORK, EN_OUR_TUTORS } from 'constants/url'
import PageContainer from 'containers/ac-containers/page-container'
import { useTranslation } from 'hooks/use-translation'
import { getState } from 'jumpstate'
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { GlobalStoreState } from 'states/app'
import { ConnectState } from 'states/connect'
import { buildType, NODE_ENV } from './const'
import ReferralHistory from './referral-history'
import styles from './styles.scss'

const cx = cls(styles)
let modalClose: () => void
let fbHref: string;
if (buildType === 'prod') {
	fbHref = `www.air-class.com`;
} else {
	// 需要在facebook后台配置
	fbHref = `${NODE_ENV === 'development' ? '172.26.120.128:8300' : 'test.air-class.com'}`;
}

function Link(props: { url: string; children: React.ReactNode }) {
	const app: GlobalStoreState = getState().app;
	const handleLinkClick = () => {
		if (props.url) history.push(props.url.replace(/:countryCode/, app.countryCode))
	}

	return (<li onClick={handleLinkClick}>{props.children}</li>)
}

let copyTimeOutId: number
function InviteFriendsIndex() {
	const userInfo = useSelector((state: ConnectState) => state.app.user)
	const [emailVal, setEmailVal] = useState('')
	const [emailSentLoading, setEmailSentLoading] = useState(false)
	const [personalLink, setPersonalLink] = useState(`${window.location.protocol}//${fbHref}/login?inviteId=${userInfo?.userId}`)
	const [copyStatus, setCopyStatus] = useState(0)
	const alertRef = useRef<HTMLDivElement | null>(null)
	const { transData, } = useTranslation('inviteFriends')
	const { h1, left, right, modal, alert } = transData
	sendEvent({
		eventId: 'EAF_a2f6002482b92172'
	})

	const handleFbShareClick = function () {
		sendEvent({
			eventId: 'EAF_65ca233e03488806'
		})
		try {
			window.FB && window.FB.ui({
				method: 'share',
				href: personalLink,
				display: 'popup'
			}, function (response: any) {
				console.log(response);
			});
		} catch (e) {
			throw new Error('fb 分享sdk加载出错')
		}
	}
	const handleEmailChange = function (e: React.ChangeEvent<HTMLInputElement>) {
		const value = e.target.value
		setEmailVal(value)
	}
	const handleSendInviteClick = function () {
		sendEvent({
			eventId: 'EAF_1c2f4b33581be11a'
		})
		if (!emailVal) {
			Alert.warn(alert.warn1, {
				container: alertRef.current,
			})
			return
		}
		const emailAddr: string[] = emailVal.split(',')
		const flag = emailAddr.some(v => {
			return v !== '' && !(emailReg.test(v))
		})
		if (flag) {
			Alert.warn(alert.warn2, {
				container: alertRef.current,
			})
			return
		}
		try {
			setEmailSentLoading(true)
			sendInviteEmails({ emailList: emailAddr.join(';') }).then(() => {
				setEmailVal('')
				Alert.success(alert.success, {
					container: alertRef.current,
				})
			})
		} finally {
			setEmailSentLoading(false)
		}

	}
	const handleCopyClick = async function () {
		sendEvent({
			eventId: 'EAF_6d48440fed58143f'
		})
		try {
			const clipboard = navigator.clipboard
			await clipboard && clipboard.writeText(personalLink)
			setCopyStatus(1)
			Alert.success(alert.success1, {
				container: alertRef.current,
			})
			copyTimeOutId = window.setTimeout(() => {
				setCopyStatus(0)
				clearTimeout(copyTimeOutId)
				copyTimeOutId = 0
			}, 5000)
		} catch (err) {
			throw new Error(err)
		}
	}

	const handleHistoryClick = function () {
		sendEvent({
			eventId: 'EAF_b4455a0e92bfccc9'
		})
		modalClose = DisplayModal.show({
			title: right.history,
			onOk() {
				modalClose()
			},
			className: 'referral-history-modal',
			content: <ReferralHistory transData={modal} />
		})
	}

	return (
		<PageContainer className={cx('invite-friends-page')}>
			<div className={cx('alert-wrap')} ref={alertRef}></div>
			<section className={cx('invite-friends_wrap')}>
				<div className={cx('wrap-left')}>
					<div className={cx('wrap-left_inner')}>
						<div className={cx('invite-banner_wrap')}>
							<img src={transData.bgImg} alt='img-invite' />
						</div>
						<div className={cx('intro-wrap')}>
							<h1 className={cx('intro-title')}>{h1}</h1>
							<ul className={cx('intro-tunnel_list')}>
								<li className={cx('list-item_friend')}>
									<p className={cx('list-item_title')}>
										<i>{left[0].i}</i>
										<span>{left[0].span}</span>
									</p>
									<ul>
										<Link url={EN_OUR_TUTORS}>{left[0].links[0]}</Link>
										<Link url={EN_HOW_WORK}>{left[0].links[1]}</Link>
										<Link url={EN_BECOME_TUTORS}>{left[0].links[2]}</Link>
										<Link url={EN_DOWNLOAD}>{left[0].links[3]}</Link>
									</ul>
								</li>
								<li className={cx('list-item_share-link')}>
									<p className={cx('list-item_title')}>
										<i>{left[1].i}</i>
										<span>{left[1].span}</span>
									</p>
									<ul>
										<li>
											<AcIcon icon="icon_facebook" />
											<span>{left[1].spans[0]}</span>
										</li>
										<li>
											<AcIcon icon="icon_mail" />
											<span>{left[1].spans[1]}</span>
										</li>
										<li>
											<AcIcon icon="icon_link" />
											<span>{left[1].spans[2]}</span>
										</li>
									</ul>
								</li>
								<li className={cx('list-item_reward')}>
									<p className={cx('list-item_title')}>
										<i>{left[2].i}</i>
										<span>{left[2].span}</span>
									</p>
									<p className={cx('desc')}>{left[2].p}</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className={cx('wrap-right')}>
					<h1 className={cx('invite-form_title')}>{right.h1}</h1>
					<div className={cx('invite-form_desc')}>
						<p>{right.desc}</p>
						<p dangerouslySetInnerHTML={{ __html: right.content }} />

					</div>
					<Button type='primary' className={cx('fb-share_btn')} onClick={handleFbShareClick}>
						<AcIcon icon={'icon_facebook'} />
						<span>{right.fb_btn}</span>
					</Button>
					<p className={cx('form-divide')}><span>{right.or}</span></p>
					<div className={cx('email-share')}>
						<Input
							value={emailVal}
							placeholder='Eg: allener@gmail.com, bobneo@gmail.com'
							className={cx('email-ipt')}
							onChange={handleEmailChange}
						/>
						<Button
							loading={emailSentLoading}
							className={cx('email-share_btn')}
							onClick={handleSendInviteClick}>
							<AcIcon icon={'icon_mail'} />
							<span>{right.send}</span>
						</Button>
					</div>
					<p className={cx('form-divide')}><span>{right.or}</span></p>
					<div className={cx('link-share')}>
						<p className={cx('link-share_title')}>{right.link}</p>
						<div className={cx('handle-wrap')}>
							<Input value={personalLink} className={cx('copy-ipt', copyStatus ? 'selected' : '')} />
							<button disabled={!!copyStatus} onClick={handleCopyClick}>{copyStatus ? right.copied : right.copy}</button>
						</div>
					</div>
					<Button type='minor' style={{ 'width': '100%' }} onClick={handleHistoryClick}>{right.history}</Button>
				</div>
			</section>
		</PageContainer>
	)
}

export default InviteFriendsIndex
